import { AssetConfig } from "../index";

export const FuelTypeAssetConfig: AssetConfig = {
    name: {type: "STRING",required: true,editable: true,label: "Name",rank: 1},
}
